import * as dayjs from 'dayjs';
import { Component, computed, input, Signal } from '@angular/core';
import { LocalizationMixinSignals } from '../../../core/mixins/localization-mixin-signal';
import { EmptyClass, EventDateFormat, Language, LocalizedDateFormatPresets, TimeZoneRegion, toEnumFromString, TrueTime } from 'in-time-core';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  standalone: true,
  selector: 'app-start-date',
  templateUrl: './start-date.component.html',
})
export class StartDateComponent extends LocalizationMixinSignals(EmptyClass) {
  public readonly startDate = input.required<dayjs.Dayjs>();
  public readonly eventDateFormat = input.required<EventDateFormat>();
  public readonly timezone = input.required<TimeZoneRegion>();

  private readonly eventDateSoon = toSignal(this.getLocalization$('event.soon'));

  public readonly date = computed(() => {
    const locale = this.locale().countryCode;
    const languageCode = this.locale().languageCode;
    const language: Language = toEnumFromString(languageCode, Language);
    if(this.eventDateFormat() === EventDateFormat.Soon) {
      return this.eventDateSoon();
    }

    const now = TrueTime.now();
    let formatter: string;
    if(this.startDate().year() === now.year()) {
      if(this.eventDateFormat() === EventDateFormat.DateTime) {
        formatter = LocalizedDateFormatPresets.MMMMDHHmm().formatters.get(language)?.formatter ?? 'MMMM DD., HH:mm';
      }
      else {
        formatter = LocalizedDateFormatPresets.MMMMD().formatters.get(language)?.formatter ?? 'MMMM DD.';
      }
    }
    else {
      if(this.eventDateFormat() === EventDateFormat.DateTime) {
        formatter = LocalizedDateFormatPresets.MMMMDHHmm().formatters.get(language)?.formatter ?? 'YYYY. MMMM DD., HH:mm';
      }
      else {
        formatter = LocalizedDateFormatPresets.MMMMD().formatters.get(language)?.formatter ?? 'YYYY. MMMM DD.';
      }
    }

    return this.startDate()
      .tz(this.timezone())
      .locale(locale)
      .format(formatter);
  });
}
